exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iconfont[data-v-e88bb144]{margin-left:7px;font-size:24px;margin-top:-7px;z-index:1;color:#bbb;margin-bottom:-7px}.c_row-item[data-v-e88bb144]{margin-bottom:20px}.color-box[data-v-e88bb144]{width:79%}.color-box .color-item span[data-v-e88bb144]{margin-left:10px;color:#1890ff;font-size:13px;cursor:pointer}", ""]);

// exports
